import { Button } from '@teamsparta/stack-button';
import { StackThemeProvider } from '@teamsparta/stack-core';

import CustomLink from '@/components/common/CustomLink';
import Only from '@/components/common/Only';
import { CommunityLayout } from '@/pages/community/shared';

import { DeletedAlertDialog } from './components';

export function DeletedPostDetailTemplate() {
  return (
    <CommunityLayout>
      <DeletedAlertDialog.Root open={true}>
        <DeletedAlertDialog.Portal>
          <DeletedAlertDialog.Overlay />
          <StackThemeProvider theme='hanghaeLight'>
            <DeletedAlertDialog.Content>
              <DeletedAlertDialog.Title>
                삭제된 글입니다.
              </DeletedAlertDialog.Title>
              <Only.Desktop>
                <CustomLink href='/community' style={{ alignSelf: 'flex-end' }}>
                  <Button
                    size='lg'
                    style={{ width: '100px' }}
                    colorScheme='secondary'
                  >
                    확인
                  </Button>
                </CustomLink>
              </Only.Desktop>
              <Only.Mobile>
                <CustomLink href='/community' fullWidth>
                  <Button size='lg' fullWidth colorScheme='secondary'>
                    확인
                  </Button>
                </CustomLink>
              </Only.Mobile>
            </DeletedAlertDialog.Content>
          </StackThemeProvider>
        </DeletedAlertDialog.Portal>
      </DeletedAlertDialog.Root>
    </CommunityLayout>
  );
}
